import Card from "../components/Card/Card";
import { Helmet } from "react-helmet";
import sendRequest from "hooks/useAxios";
import sendRequest2 from "hooks/useAxios2";
import { sendRequestAPI4 } from "hooks/useAxios";
// import pics
import UpdateOrderModal from "common/order/UpdateOrderModal";
import StatusReportModal from "common/order/StatusReportModal";
import order from "../assets/images/2799166.png";
import repair from "../assets/images/1698478.png";
import sale from "../assets/images/3211590.png";
import { useEffect, useState } from "react";
// icons
import { MdOutlineSpaceDashboard } from "react-icons/md";
// import { createPortal } from "react-dom";
import Pagination from "rc-pagination";
import { ProductsOrder } from "common/order/ProductsOrder";
import Title from "common/Title";
// import AddProductModal from "components/admin-panel/addProductModal/AddProductModal";
function AdminDashboard({ logo }) {
  const [adminInfo, setAdminInfo] = useState({});
  const [orderLists, setOrderLists] = useState([]);
  const [selectedItem, setSelectedItem] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [updater, setUpdater] = useState(false);
  const [updater2, setUpdater2] = useState(false);
  const [chatList, setChatList] = useState([]);
  const updateSelectedItem = (information) => {
    setSelectedItem(information);
    setChatList(information.chats);
  };
  useEffect(() => {
    sendRequest("getordergeneralinfo").then(({ data }) => {
      setAdminInfo(data);
    });
  }, []);
  // state info from api

  useEffect(() => {
    sendRequestAPI4("newfilterorder").then(({ data }) => {
      setOrderLists(data.info);
    });
  }, []);

  return (
    <>
      <div>
        <Helmet>
          <meta charSet="utf-8" />
          <title>{`داشبورد ادمین`} </title>
          {/* <link rel="shortcut icon" href={`${logo}`} /> */}
        </Helmet>
      </div>
      <Title
        color="rgb(244 124 96)"
        title="داشبورد"
        icon={MdOutlineSpaceDashboard}
      />
      <div className="d-flex flex-wrap m-2">
        {/* {createPortal(
        <AddProductModal></AddProductModal>,
        document.getElementById("modals")
      )} */}
        <StatusReportModal
          selectedItem={selectedItem}
          pageType="0"
          setUpdater={setUpdater}
        ></StatusReportModal>
        <UpdateOrderModal
          selectedItem={selectedItem}
          updateSelectedItem={updateSelectedItem}
          orderUpdater={setUpdater}
        ></UpdateOrderModal>

        <>
          <div className="col-sm-4 col-6">
            <Card
              title="تعداد سفارشات جاری"
              lightColor="#F2CC5B"
              darkColor="#B89B45"
              number={adminInfo.currentOrders}
              imgSrc={order}
              underline={true}
            ></Card>
          </div>
          <div className="col-sm-4 col-6">
            <Card
              title="تعداد سفارش گروهی"
              lightColor="#503E9D"
              darkColor="#281F4F"
              number={adminInfo.repair}
              imgSrc={repair}
              underline={true}
            ></Card>
          </div>
          <div className="col-sm-4 col-6">
            <Card
              title="تعداد فروش"
              lightColor="#56A689"
              darkColor="#3E7763"
              number={adminInfo.Sale}
              imgSrc={sale}
              underline={true}
            ></Card>
          </div>
        </>
        <div>
          {/* <button
          className="btn btn-primary "
          data-bs-target="#addProductModal"
          data-bs-toggle="modal"
        >
          افزودن محصول
        </button> */}
        </div>
        <div className="order-container">
          {orderLists
            .slice((currentPage - 1) * 5, (currentPage - 1) * 5 + 5)
            .map((value, index) => {
              console.log("***p", value);
              if (value.type == "0") {
                return (
                  <ProductsOrder
                    data={value}
                    index={index}
                    updateSelectedItem={updateSelectedItem}
                    pageType="superadmin"
                  ></ProductsOrder>
                );
              }
            })}
        </div>
      </div>
      <div className="d-flex justify-content-center mt-4">
        <div>
          <Pagination
            style={{ direction: "ltr" }}
            total={orderLists.filter((i) => i.type == "0").length}
            pageSize={5}
            current={currentPage}
            onChange={(newPage) => {
              setCurrentPage(newPage);
            }}
          ></Pagination>
        </div>
      </div>
    </>
  );
}

export default AdminDashboard;
